import React from "react";
import Header from "../components/Header";
import FeaturedCategories from "../components/FeaturedCategories";
import ProductList from "../components/ProductList";
import ShopTeaTime from "../components/ShopTeaTime";
import brands from "../assets/img/home-page-brands.png";
import { Slide, Fade } from "react-awesome-reveal";
import SalesList from "../components/SalesList";
import { Link } from "react-router-dom";

function HomePage() {
  return (
    <>
      <Header />
      <div className="container mt-0 d-flex flex-column justify-content-center align-items-center pb-5">
        <h1 className="h5 my-2 pt-4 my-md-5 pt-md-5 text-center">
          FEATURED PRODUCTS
        </h1>
        <ProductList />
        <h2 className="h5 my-5 pt-5 text-center">FEATURED CATEGORIES</h2>
        <Slide direction="right">
          <Fade>
            <FeaturedCategories />
          </Fade>
        </Slide>
        <h3 className="h5 my-5 pt-5 text-center">WHAT'S ON SALE</h3>
        <SalesList productQty={8} />
        <Link
          to="/products/sale"
          className="mt-5 btn btn-yellow d-flex align-items-center"
        >
          VIEW ALL
        </Link>
        <h4 className="h5 my-5 pt-5 text-center tea-time-title">
          SHOP TEATIME FAVOURITES
        </h4>
        <Fade className="animation-container">
          <ShopTeaTime />
        </Fade>
        <p className="h4 mt-5 mb-3">WE WHOLESALE HARNEY & SONS IN CANADA</p>
        <p className="f-roboto">
          Are you interested in offering Harney & Sons Fine Teas at your
          business establishment - we are happy to assist.
        </p>
        <button className="btn btn-yellow fs-7 mb-5">INQUIRE NOW</button>
        <Fade>
          <img src={brands} alt="brands" className="my-5 img-fluid" />
        </Fade>
      </div>
    </>
  );
}

export default HomePage;
